import repotCSVRedux from '../../views/list/redux/slice'

//export redux objects
export default {
	repotCSVRedux
};